module.exports = __webpack_public_path__ + "static/img/17.6ec9de1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/1/sp/17.png
// module id = 7sFk
// module chunks = 0